import { useId } from 'react';

export function useIds(passedId: string | undefined) {
  const generatedId = useId();
  const rootId = passedId || generatedId;
  return {
    rootId,
    labelId: `${rootId}-label`,
    inputId: `${rootId}-input`,
    errorId: `${rootId}-error`,
    hintId: `${rootId}-hint`,
    suffixId: `${rootId}-suffix`,
    prefixId: `${rootId}-prefix`,
    descriptionId: `${rootId}-description`,
    metaId: `${rootId}-meta`,
  };
}
